import { createAction, props } from '@ngrx/store';

import { AnalyticsState } from '@app/core/analytics.reducer';

export const updateAnalyticsProperties = createAction('[Analytics] Update', props<{ updates: AnalyticsState }>());
